// /src/NavLinks.js
import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = () => {
    return (
        <>
            <HashLink className="block lg:inline-block px-4 py-2 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/#about">
                About
            </HashLink>
            <HashLink className="block lg:inline-block px-4 py-2 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/#services">
                Services
            </HashLink>
            <HashLink className="block lg:inline-block px-4 py-2 font-extrabold text-gray-500 hover:text-blue-900" to="/#products">
                Products
            </HashLink>
            <HashLink className="block lg:inline-block px-4 py-2 font-extrabold text-gray-500 hover:text-blue-900" to="/#clients">
                Clients
            </HashLink>
            <HashLink className="block lg:inline-block px-4 py-2 font-extrabold text-gray-500 hover:text-blue-900" to="/#team">
                Team
            </HashLink>
            <HashLink className="block lg:inline-block px-4 py-2 font-extrabold text-gray-500 hover:text-blue-900" to="/contact#contact">
                Contact Us
            </HashLink>
        </>
    );
}

export default NavLinks;
